import { render, staticRenderFns } from "./ListPixTransactions.vue?vue&type=template&id=45d9671c&scoped=true"
import script from "./ListPixTransactions.vue?vue&type=script&lang=js"
export * from "./ListPixTransactions.vue?vue&type=script&lang=js"
import style0 from "./ListPixTransactions.vue?vue&type=style&index=0&id=45d9671c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d9671c",
  null
  
)

export default component.exports